// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".X1Mfl{display:block}.fPo8z{color:#767676}.WuhU4{font-size:14px;line-height:24px}a.WuhU4{color:#0082ff;cursor:pointer;text-decoration:none;transition:color .2s}a.WuhU4:active{-webkit-tap-highlight-color:rgba(0,0,0,0);color:#006ee1}@media(any-hover:hover){a.WuhU4:hover{color:#006ee1}}.RR-iP{color:rgba(240,45,55,.8);font-size:16px;grid-gap:4px;gap:4px;line-height:20px}@media screen and (min-width:768px){.RR-iP{font-size:18px}}.RR-iP .WuhU4{font-size:inherit;line-height:20px}.RR-iP .WuhU4:first-child{margin-right:4px;float:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listOfValues": "X1Mfl",
	"admark": "fPo8z",
	"value": "WuhU4",
	"advMarker": "RR-iP"
};
module.exports = ___CSS_LOADER_EXPORT___;
